// Google Analytics 4 event helpers (gtag configured in public/index.html, ID G-8PF5L2DJ49)
// Pinterest Tag helpers (pintrk configured in public/index.html, Tag ID 2614056586677)
export function track(eventName, params = {}) {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", eventName, params);
    }
  } catch (e) {
    console.debug("Analytics call failed:", e?.message);
  }
}

export function pinTrack(eventName, params = {}) {
  try {
    if (typeof window !== "undefined" && typeof window.pintrk === "function") {
      window.pintrk("track", eventName, params);
    }
  } catch (e) {
    console.debug("Analytics call failed:", e?.message);
  }
}

// SPA route change pageview (GA4 + Pinterest)
export function trackPageView(path) {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", "page_view", { page_path: path });
    }
    if (typeof window !== "undefined" && typeof window.pintrk === "function") {
      window.pintrk("track", "pagevisit");
    }
  } catch (e) {
    console.debug("Analytics call failed:", e?.message);
  }
}

// First-party visit tracking → Admin Traffic tab (anonymous, no cookies)
let lastVisitPath = "";
export function recordVisit(path) {
  try {
    if (path.startsWith("/admin") || path === lastVisitPath) return;
    lastVisitPath = path;
    let vid = localStorage.getItem("rj_vid");
    if (!vid) {
      vid = (window.crypto?.randomUUID?.() || `${Math.random().toString(36).slice(2)}${Date.now()}`);
      localStorage.setItem("rj_vid", vid);
    }
    if (!sessionStorage.getItem("rj_utm")) {
      const params = new URLSearchParams(window.location.search);
      sessionStorage.setItem("rj_utm", params.get("utm_source") || "");
    }
    const ref = document.referrer && !document.referrer.includes(window.location.host) ? document.referrer : "";
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json", "X-API-Key": process.env.REACT_APP_SITE_API_KEY },
      body: JSON.stringify({
        vid,
        path,
        referrer: ref,
        utmSource: sessionStorage.getItem("rj_utm") || "",
        device: window.innerWidth < 768 ? "mobile" : "desktop",
      }),
      keepalive: true,
    }).catch(() => {});
  } catch (e) {
    console.debug("Visit tracking failed:", e?.message);
  }
}

export const trackViewItem = (product) => {
  track("view_item", {
    currency: "USD",
    value: product.price,
    items: [{ item_id: product.handle, item_name: product.title, price: product.price }],
  });
  pinTrack("pagevisit", {
    currency: "USD",
    value: product.price,
    line_items: [{ product_id: product.handle, product_name: product.title, product_price: product.price }],
  });
};

export const trackViewItemList = (listName, count) => {
  track("view_item_list", { item_list_name: listName, item_count: count });
  pinTrack("viewcategory", { category_name: listName });
};

export const trackSearch = (term) => {
  track("search", { search_term: term });
  pinTrack("search", { search_query: term });
};

export const trackInquiry = (productTitle) => {
  track("generate_lead", { lead_type: "inquiry", product: productTitle || "general" });
  pinTrack("lead", { lead_type: "inquiry" });
};

export const trackAppointment = () => {
  track("generate_lead", { lead_type: "appointment_request" });
  pinTrack("lead", { lead_type: "appointment_request" });
};

export const trackContactClick = (method) => track("contact_click", { method });

export const trackSubscribe = () => {
  track("sign_up", { method: "newsletter" });
  pinTrack("signup", { signup_type: "newsletter" });
};
